export default __webpack_public_path__ + "static/image/image008.dc28248b.jpg";